module.exports = __webpack_public_path__ + "static/media/CTLI_16-111w.0c59b7b4.jpg";